import { useServices } from 'hooks/useServices';
import { TServices } from 'types/services';
import { useAsyncBoundary } from 'utils/asyncBoundary/asyncBoundaryHooks';
import { AsyncBoundaryInjectorParams } from 'utils/asyncBoundary/asyncBoundaryTypes';

type AsyncProcessCallback = (methods: TServices) => Promise<void>;

export const useAsyncProcess = () => {
  const { injectPromise } = useAsyncBoundary();

  const services = useServices();

  return (
    callback: AsyncProcessCallback,
    params?: AsyncBoundaryInjectorParams
  ) => {
    injectPromise(callback(services), params);
  };
};
